import { render, staticRenderFns } from "./houseDetail.vue?vue&type=template&id=50ead628&scoped=true&"
import script from "./houseDetail.vue?vue&type=script&lang=js&"
export * from "./houseDetail.vue?vue&type=script&lang=js&"
import style0 from "./houseDetail.vue?vue&type=style&index=0&id=50ead628&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ead628",
  null
  
)

export default component.exports